"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var ModalRoutingContext = /*#__PURE__*/_react.default.createContext({
  isModal: false,
  closeTo: null
});

var _default = ModalRoutingContext;
exports.default = _default;